const dialog = {
    content: {
        padding: '0',
    },
};

export default dialog;
